import React from 'react';
import { withTranslation } from 'react-i18next';

function RoomAttendant(props) {
  const { t, attendant, helper, hide } = props;
  return !hide?<div className="room-attendant">
    <div className="title">{t('Attendant')}</div>
    {attendant?
      <>
      <span>{props.attendant.firstName} {props.attendant.lastName} </span>
      {helper?
        <div>{helper.firstName} {helper.lastName} </div>
      :null}
      </>
    :
      <span className="no-attendant text-danger">{t("No Attendant")}</span>
    }
    
  </div>
  :null
}

export default withTranslation()(RoomAttendant);